import { render, staticRenderFns } from "./item-thumb.component.vue?vue&type=template&id=3c04fab9&lang=pug"
import script from "./item-thumb.component.vue?vue&type=script&lang=ts"
export * from "./item-thumb.component.vue?vue&type=script&lang=ts"
import style0 from "./item-thumb.component.vue?vue&type=style&index=0&id=3c04fab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports